<template>
  <!-- 二维地图功能面板 -->
  <div :class="allEyesModel?'infoPanel_eyeshield':'infoPanel'" v-show="isDetailOpen">
    <div class="taskContentAll" v-show="open">
      <div class="bottomWrap">
        <div class="itemTitle" style="position: relative">
          <div>
            实时飞行
          </div>
          <div class="handelPlaneBtns" v-show="clickPlaneInfo.id">
            <span @click="clickStart(clickPlaneInfo)" :class="isStartClick?'qifeiBtnClick':'qifeiBtn'" title="起飞"></span>
            <span @click="clickPause(clickPlaneInfo)" :class="isPauseClick?'zantingBtnClick':'zantingBtn'" title="暂停航线"></span>
            <span @click="clickContinue(clickPlaneInfo)" :class="isContinueClick?'jixuBtnClick':'jixuBtn'" title="继续航线"></span>
            <span @click="clickDown(clickPlaneInfo)" :class="isDownClick?'fanhangBtnClick':'fanhangBtn'" title="返航"></span>
            <span @click="sendData()" class="dataSend" title="数据协同"></span>
          </div>
        </div>

        <div class="BottomContent">
          <FlightDetailRealTime
            :allEyesModel="allEyesModel"
            :clickPlaneInfo="clickPlaneInfo"
            :planeChartData="planeChartData"
            :planeDetailData="planeDetailData"
            :isHistory="isHistory"
            :playOrPause="playOrPause"
            :replaySpeed="replaySpeed"
            :taskPlan="taskPlan"
            :currentPoint="lastPoint"
          ></FlightDetailRealTime>
        </div>
      </div>
      <div class="topWrap">
        <div class="itemTitle">
          <span>
            飞行详情
          </span>
        </div>
        <div class="TopContent">
          <div class="routeWrap">
            <div :title="planeDetailData.startPoint?planeDetailData.startPoint.name:NaN">
              {{planeDetailData.startPoint?planeDetailData.startPoint.name.length>=4?planeDetailData.startPoint.name.slice(0, 3)+'...':planeDetailData.startPoint.name:'— —'}}
            </div>
            <div  :title="planeDetailData.endPoint?planeDetailData.endPoint.name:NaN"> {{planeDetailData.endPoint?planeDetailData.endPoint.name.length>=4?planeDetailData.endPoint.name.slice(0, 3)+'...':planeDetailData.endPoint.name:'— —'}}
            </div>
          </div>
<!--          <div class="timeWrap">-->
<!--            <div class="timeGroup">-->
<!--              <div class="timeItem">-->
<!--                <span class="heiti timeKey">计划起飞</span>-->
<!--                <span class="zhengDao time">{{planeDetailData.startTime?getTargetTimeStr(planeDetailData.startTime):NaN}}</span>-->
<!--              </div>-->
<!--              <div class="timeItem">-->
<!--                <span class="heiti timeKey">计划降落</span>-->
<!--                <span class="zhengDao time">{{planeDetailData.endTime?getTargetTimeStr(planeDetailData.endTime):NaN}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="timeGroup">-->
<!--              <div class="timeItem">-->
<!--                <span class="heiti timeKey">实际起飞</span>-->
<!--                <span class="zhengDao time">{{planeDetailData.actualST?getTargetTimeStr(planeDetailData.actualST):NaN}}</span>-->
<!--              </div>-->
<!--              <div class="timeItem">-->
<!--                <span class="heiti timeKey">实际降落</span>-->
<!--                <span class="zhengDao time">{{planeDetailData.actualET?getTargetTimeStr(planeDetailData.actualET):NaN}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div class="timeWrap">
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">计划起飞时间</div>
                <div class="timeData">{{planeDetailData.startTime?getTargetTimeStr(planeDetailData.startTime):'— —'}}</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">计划降落时间</div>
                <div class="timeData">{{planeDetailData.endTime?getTargetTimeStr(planeDetailData.endTime):'— —'}}</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">实际起飞时间</div>
                <div class="timeData">{{planeDetailData.actualST?getTargetTimeStr(planeDetailData.actualST):'— —'}}</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
            <div class="timeGroup">
              <div class="timeItem">
                <div class="timeName">实际降落时间</div>
                <div class="timeData">{{planeDetailData.actualET?getTargetTimeStr(planeDetailData.actualET):'— —'}}</div>
              </div>
              <div class="timeSeparate">
              </div>
            </div>
          </div>


        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {wgs84ToGcj02} from "../../../src/assets/js/map/ConverseLngAndLa";
import FlightDetailRealTime from "../home/smallModel/flightera.vue"

export default {
  components:{FlightDetailRealTime},
  props: {
    //护眼模式
    allEyesModel:{
      type: Boolean,
      default: false
    },
    //是否打开
    isDetailOpen: {
      type: Boolean,
      default: false
    },
    changeDetailOpen: {
      type: Function,
      default: null
    },
    planeChartData: {
      type: Array,
      default: []
    },
    planeDetailData: {
      type: Object,
      default: {}
    },
    clickPlaneInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },

  },
  watch: {
    clickPlaneInfo(){
        if(this.clickPlaneInfo.id !== this.planeId){
          this.planeId = this.clickPlaneInfo.id
          //重置飞机按钮状态
          this.isStartClick = false
          this.isPauseClick = false
          this.isContinueClick = false
          this.isDownClick = false
        }
    },
    runTask() {
      this.changeRunTask = this.runTask.map(v => ({
        ...v,
        startChecked: false,
        changeChecked: false,
        downChecked: false
      }))
    }
  },

  data() {
    return {
      planeId:null,
      isStartClick:false,
      isPauseClick:false,
      isContinueClick:false,
      isDownClick:false,
      isHistory: false, //是否是历史详情
      playOrPause: false, //暂停或播放轨迹
      replaySpeed: 1, //轨迹回放倍数
      lastPoint: { heading: 180, roll: 0, pitch: 0 }, //最后一个点信息
      taskPlan: {}, //计划信息
      // 存储被点击的id
      startIds: [],
      changeIds: [],
      downIds: [],

      //处理之后的数据
      changeRunTask: [],

      // active1: false,
      // active2: false,
      // active3: false,
      // active4: false,
      // active5: false,
      // active6: false,
      open: true,
      openDetail: true,
      searchEvent: '',
      searchRealTask: '',
      searchPreTask: '',

    };
  },
  mounted() {

  },
  methods: {
    sendData(){
      setTimeout(()=>{
        this.$message({
          message: '发送成功',
          duration: 1000,
          customClass: "message-s",
          iconClass: "el-icon-ok-tip",
          offset: 470,
          onClose: function () {
          },
        });
      },2000)
    },
    getTargetTimeStr(v){
      const date = new Date(v);
      const hours = String(date.getHours()).padStart(2, '0'); // 确保两位数
      const minutes = String(date.getMinutes()).padStart(2, '0'); // 确保两位数
      return`${hours}:${minutes}`;
    },
    //起飞
    clickStart(info) {
        if(info.uasID){
          let data = {
            command: 1,
            orderID: info.orderID,
            uasID: info.uasID,
            uasModel: info.uavModel
          };
          this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
            res => {
              if (res.status == 200) {
                if (res.data.code == 0) {
                  this.isStartClick = true
                  this.$message.success({
                    message: "执行起飞指令成功",
                    duration: 1000,
                    customClass: "message-s",
                    iconClass: "el-icon-ok-tip",
                    offset: 470,
                    onClose: function() {}
                  });
                } else {
                  this.$message.error({
                    message: "执行起飞指令失败",
                    duration: 1000,
                    customClass: "message-warn-s",
                    iconClass: "el-icon-warn-tip",
                    offset: 470,
                    onClose: function() {}
                  });
                }
              }
            }
          );
        }
    },
    //暂停
    clickPause(info) {
      if(info.uasID){
        let data = {
          command: 8,
          orderID: info.orderID,
          uasID: info.uasID,
          uasModel: info.uavModel
        };

        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.isPauseClick = true
                this.$message.success({
                  message: "执行暂停航线指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function() {}
                });
              } else {
                this.$message.error({
                  message: "执行暂停航线指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function() {}
                });
              }
            }
          }
        );
      }

    },
    //继续
    clickContinue(info) {
      if(info.uasID){
        let data = {
          command: 11,
          orderID: info.orderID,
          uasID: info.uasID,
          uasModel: info.uavModel
        };
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.isContinueClick = true
                this.$message.success({
                  message: "执行继续航线指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function() {}
                });
              } else {
                this.$message.error({
                  message: "执行继续航线指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function() {}
                });
              }
            }
          }
        );
      }
    },
    //降落
    clickDown(info) {
      if(info.uasID){
        let data = {
          command: 12,
          orderID: info.orderID,
          uasID: info.uasID,
          uasModel: info.uavModel
        };
        this.postJsonRequest("/uav-task-server/flightCommand/sendCommand", data).then(
          res => {
            if (res.status == 200) {
              if (res.data.code == 0) {
                this.isDownClick = true
                this.$message.success({
                  message: "执行返航指令成功",
                  duration: 1000,
                  customClass: "message-s",
                  iconClass: "el-icon-ok-tip",
                  offset: 470,
                  onClose: function() {}
                });
              } else {
                this.$message.error({
                  message: "执行返航指令失败",
                  duration: 1000,
                  customClass: "message-warn-s",
                  iconClass: "el-icon-warn-tip",
                  offset: 470,
                  onClose: function() {}
                });
              }
            }
          }
        );
      }

    }
  }
};
</script>

<style scoped lang="scss">
  // 非护眼模式
    .infoPanel {
      height: 100%;
      overflow: auto;
      width: 346px !important;
      //width: auto;
      //position: absolute;
      background: rgba(0,28,52, 0.68);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .chooseBtn {
        width: 38px;
        height: 38px;
        cursor: pointer;
        text-align: center;
        position: relative;
        margin-bottom: 20px;
        margin-left: 167px;
      }
      .dataSend{
        background-image: url("../../assets/img/2dmap/data.png");
        background-size: contain;
      }
      .routeWrap {
        margin-top: 12px;
        width: calc(100% - 20px);
        height: 28px;
        background-image: url("../../assets/img/2dmap/qi_zhong_dian.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
      }
      .routeWrap > div {
        position: relative;
        white-space: nowrap;
        height: 20px;
        width: 80px;
        font-size: 20px;
        font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
        margin-bottom: 8px;
      }

      .routeWrap > div > span {
        display: none;
        font-size: 16px;
        position: absolute;
        color: #fff;
        top: -30px;
        left: -10px;
        z-index: 1003;
      }

      .routeWrap > div:hover > span {
        display: block;
      }
      .topWrap {
        height: 35%;
        width: 100%;
        padding: 0 10px 0px 10px;
      }
      .bottomWrap{
        height: 65%;
      }
      .handelPlaneBtns{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        width: 160px;
        position: absolute;
        right: 20px;
        top: 0;
      }
      .handelPlaneBtns > span{
        display: block;
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
      .handelPlaneBtns .qifeiBtn{
        background-image: url("../../assets/img/2dmap/qifei.png");
      }
      .handelPlaneBtns .qifeiBtnClick{
        background-image: url("../../assets/img/2dmap/qifei_click.png");
      }
      .handelPlaneBtns .zantingBtn{
        background-image: url("../../assets/img/2dmap/xuan_ting_normal.png");
      }
      .handelPlaneBtns .zantingBtnClick{
        background-image: url("../../assets/img/2dmap/pause_click.png");
      }
      .handelPlaneBtns .jixuBtn{
        background-image: url("../../assets/img/2dmap/continue.png");
      }
      .handelPlaneBtns .jixuBtnClick{
        background-image: url("../../assets/img/2dmap/continue_click.png");
      }
      .handelPlaneBtns .fanhangBtn{
        background-image: url("../../assets/img/2dmap/jiangluo.png");
      }
      .handelPlaneBtns .fanhangBtnClick{
        background-image: url("../../assets/img/2dmap/jiangluo_click.png");
      }
      .timeWrap{
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .timeWrap .timeSeparate{
          background-image: url("../../assets/img/2dmap/under_bg.png");
          width: 299px;
          height: 18px;
      }
      .timeWrap .timeData{
        font-size: 22px;
        font-family: zcoolwenyiti, zcoolwenyiti-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
      }
      .timeGroup {
        font-size: 16px;
        width: 100%;
      }

      .timeItem {
        width: 299px;
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #FFFFFF;
      }

      .timeItem .timeKey {
        font-size: 16px;
        color: #ebebeb;
      }

      .timeItem .time {
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
      }
      .BottomContent{
        overflow: auto;
        box-sizing: border-box;
        padding: 0 18px 0 18px;
        width: 346px;
        height: calc(100% - 55px);
        background: rgba(0,28,52,0.50);
        margin-top: 2px;
      }
      .open {
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 10px;
        width: 38px;
        height: 38px;
        background: rgba(15, 86, 115, 0.4);
      }

      .open img {
        width: 38px;
        height: 38px;
      }

      .taskContentAll {
        overflow: auto;
        box-sizing: border-box;
        height: 100%;
        position: absolute;
        display: flex;
        flex-direction: column; /* 子元素垂直排列 */
        flex: 1; /* 每列平分父元素宽度 */
        display: -webkit-flex;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }


      .itemTitle {
        height: 50px;
        background-image: url("../../assets/img/2dmap/pop_bg.png");
        background-size: 80% 38px;
        background-position: bottom left;
        background-repeat: no-repeat;
        padding-left: 27px;
        font-size: 24px;
        font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
        padding-top: 6px;
        box-sizing: border-box;
      }

      .topWrap .TopContent {
        width: 100%;
        height: calc(100% - 50px);
        background: rgba(0,28,52,0.50);
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      @keyframes blinker {
        from {
          opacity: 1;
        }
        to {
          opacity: 0.2;
        }
      }

      .heiti {
        font-family: Adobe Heiti Std, Adobe Heiti Std-R;
        text-align: left;
        color: #ffffff;
      }

      .zhengDao {
        font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
        text-align: left;
        color: #ffffff;
      }

      .blinking {
        -webkit-animation-name: blinker;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
        -webkit-animation-duration: 1s;
        animation-name: blinker;
        animation-iteration-count: infinite;
        animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
        animation-duration: 1s;
      }
    }
  //护眼模式
     .infoPanel_eyeshield {
      height: 100%;
      overflow: auto;
      width: 346px !important;
      background: rgba(1,6,10, 0.68);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .chooseBtn {
        width: 38px;
        height: 38px;
        cursor: pointer;
        text-align: center;
        position: relative;
        margin-bottom: 20px;
        margin-left: 167px;
      }
      .dataSend{
        background-image: url("../../assets/img/2dmap/data.png");
        background-size: contain;
      }
      .routeWrap {
        margin-top: 12px;
        width: calc(100% - 20px);
        height: 28px;
        background-image: url("../../assets/img/2dmap_eyes/qi_zhong_dian.png");
        background-size: auto;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
      }
      .routeWrap > div {
        position: relative;
        white-space: nowrap;
        height: 20px;
        width: 80px;
        font-size: 20px;
        font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
        margin-bottom: 8px;
      }

      .routeWrap > div > span {
        display: none;
        font-size: 16px;
        position: absolute;
        color: #fff;
        top: -30px;
        left: -10px;
        z-index: 1003;
      }

      .routeWrap > div:hover > span {
        display: block;
      }
      .topWrap {
        height: 35%;
        width: 100%;
        padding: 0 10px 0px 10px;
      }
      .bottomWrap{
        height: 65%;
      }
      .handelPlaneBtns{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        width: 160px;
        position: absolute;
        right: 20px;
        top: 0;
      }
      .handelPlaneBtns > span{
        display: block;
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
      .handelPlaneBtns .qifeiBtn{
        background-image: url("../../assets/img/2dmap/qifei.png");
      }
      .handelPlaneBtns .qifeiBtnClick{
        background-image: url("../../assets/img/2dmap/qifei_click.png");
      }
      .handelPlaneBtns .zantingBtn{
        background-image: url("../../assets/img/2dmap/xuan_ting_normal.png");
      }
      .handelPlaneBtns .zantingBtnClick{
        background-image: url("../../assets/img/2dmap/pause_click.png");
      }
      .handelPlaneBtns .jixuBtn{
        background-image: url("../../assets/img/2dmap/continue.png");
      }
      .handelPlaneBtns .jixuBtnClick{
        background-image: url("../../assets/img/2dmap/continue_click.png");
      }
      .handelPlaneBtns .fanhangBtn{
        background-image: url("../../assets/img/2dmap/jiangluo.png");
      }
      .handelPlaneBtns .fanhangBtnClick{
        background-image: url("../../assets/img/2dmap/jiangluo_click.png");
      }
      .timeWrap{
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .timeWrap .timeSeparate{
          display: none;
      }
      .timeWrap .timeData{
        font-size: 22px;
        font-family: zcoolwenyiti, zcoolwenyiti-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
      }
      .timeGroup {
        font-size: 16px;
        width: 100%;
      }

      .timeItem {
        width: 299px;
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #FFFFFF;
        padding: 10px;
        background: rgba(255,255,255,0.30);
      }

      .timeItem .timeKey {
        font-size: 16px;
        color: #ebebeb;
      }

      .timeItem .time {
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
      }
      .BottomContent{
        overflow: auto;
        box-sizing: border-box;
        padding: 0 18px 0 18px;
        width: 346px;
        height: calc(100% - 55px);
        background: #01060a;
        margin-top: 2px;
      }
      .open {
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 10px;
        width: 38px;
        height: 38px;
        background: rgba(15, 86, 115, 0.4);
      }

      .open img {
        width: 38px;
        height: 38px;
      }

      .taskContentAll {
        overflow: auto;
        box-sizing: border-box;
        height: 100%;
        position: absolute;
        display: flex;
        flex-direction: column; /* 子元素垂直排列 */
        flex: 1; /* 每列平分父元素宽度 */
        display: -webkit-flex;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }


      .itemTitle {
        height: 50px;
        padding-left: 27px;
        font-size: 24px;
        font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
        padding-top: 6px;
        box-sizing: border-box;
      }
      .itemTitle::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 10px;
          width: 3px;
          height: 20px;
          background: #00aeff;
      }

      .topWrap .TopContent {
        width: 100%;
        height: calc(100% - 50px);
        background: rgba(1,6,10,1.00);
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      @keyframes blinker {
        from {
          opacity: 1;
        }
        to {
          opacity: 0.2;
        }
      }

      .heiti {
        font-family: Adobe Heiti Std, Adobe Heiti Std-R;
        text-align: left;
        color: #ffffff;
      }

      .zhengDao {
        font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
        text-align: left;
        color: #ffffff;
      }

      .blinking {
        -webkit-animation-name: blinker;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
        -webkit-animation-duration: 1s;
        animation-name: blinker;
        animation-iteration-count: infinite;
        animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
        animation-duration: 1s;
      }
    }
</style>






// WEBPACK FOOTER //
// src/components/home/PlanDetail.vue